import {
  Autocomplete,
  Checkbox,
  ListItem,
  TextField,
  Typography,
  TypographyProps,
} from "@mui/material";
import Flex, { FlexProps } from "./Flex";
import lodash from "lodash";
import { Option } from "../constants/common";

interface CustomAutocompleteProps {
  options: Option[];
  label?: string;
  flexProps?: FlexProps;
  typographyProps?: TypographyProps;
  placeholder?: string;
  optionWithCheckbox?: boolean;
  disableCloseOnSelect?: boolean;
  onChange?: (newValue: Option | null) => void;
  value?: Option | null;
  defaultValue?: Option | null;
}

const CustomAutocomplete = ({
  label,
  flexProps,
  placeholder = "Select",
  options,
  onChange,
  value,
  defaultValue,
  optionWithCheckbox = false,
  typographyProps,
  disableCloseOnSelect = false,
}: CustomAutocompleteProps) => {
  return (
    <Flex {...flexProps} flexDirection={flexProps?.flexDirection ?? "column"}>
      <Typography
        {...typographyProps}
        fontWeight={typographyProps?.fontWeight ?? 500}
      >
        {label}
      </Typography>
      <Autocomplete
        defaultValue={defaultValue ?? null}
        options={options}
        fullWidth
        disableCloseOnSelect={disableCloseOnSelect}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={lodash.isEqual}
        value={value}
        onChange={(_, value) => {
          onChange?.(value);
        }}
        renderOption={(props, option, { selected }) => (
          <ListItem key={option.label} {...props}>
            {optionWithCheckbox && <Checkbox checked={selected} />}
            {option.label}
          </ListItem>
        )}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} />
        )}
      />
    </Flex>
  );
};

export default CustomAutocomplete;
